<template>
	<Page header="Denied" type="" :nopadding="false" header_pos="left">
        <template #body>
			<div class="flex flex-column gap-3 justify-content-start align-items-left">
        	    <span class="flex">
					Доступ запрещен.
				</span>
				<div class="flex">
					<Button label="Главная" @click="go_auth" class="" severity="info" />
				</div>
			</div>
        </template>
    </Page>
</template>

<script>
import Page from '@/components/public/page.vue'

export default {
	name: 'Denied',
	components: {
		Page
	},
	methods: {
		go_auth(){
			this.$router.push('/')
		}
	}
}
</script>
